var url = process.env.API_URL + process.env.API_VERSION;
import axios from 'axios';
import cookie from 'vue-cookie';
import router from '../../router';
const state = {
  list_appointments: [],
  pagination_appointment: {},
  list_counselors: [],
  pagination_counselors: {},
  appointment_detail: {},
  list_contacts: [],
  pagination_contacts: {},
  list_reviews: [],
  pagination_review: {},
}
const mutations ={  
  load_data(state, data){
    state.list_appointments = data.appointments
    state.pagination_appointment = data.pagination
  },
  set_detail_appointment(state, data){
    state.appointment_detail = data.appointment
  },
  set_list_counselors(state, data){
    state.list_counselors = data.counselors    
    state.pagination_counselors = data.pagination
  },
  set_list_contacts(state, data){
    state.list_contacts = data.list_contacts
    state.pagination_contacts = data.pagination
  },
  set_list_reviews(state, data){
    state.list_reviews = data.list_reviews
    state.pagination_review = data.pagination
  }
}
const actions = {  
  get_list_appointments({commit}, data){    
    axios.get(url + "/appointment/list_appointment?page=" + data.page + "&keyword=" + data.keyword + "&filter=" + data.filter,
      {
        headers:{
              'Authorization': cookie.get('user-token') || ''
            }
      }
    )
    .then((response) =>{
      commit('load_data', response.data.extra)
    })
    .catch((error) => {
      if (error.response != undefined){
        alert(error.response.data.message)
      }
    })
  },
  destroy_appointment_api({commit, dispatch, state}, data){
    axios.post(url + "/appointment/destroy_appointment", 
      data,
      {
        headers: {
          'Authorization': cookie.get('user-token') || ''
        }
      }
    )
    .then((response) =>{
      dispatch('get_list_appointments', state.pagination_appointment.current_page)
    })
    .catch((error) => {
      if (error.response != undefined){
        alert(error.response.data.message)
      }else{
        console.log(error)
      }
    })
  },
  get_detail({commit}, id){
    axios.get(url + "/appointment/detail?id=" + id,
    {
      headers:{
        'Authorization': cookie.get('user-token') || ''
      }
    })
    .then((response) => {
      commit('set_detail_appointment', response.data.extra)
    })
    .catch((error) => {
      if (error.response != undefined) {
        alert(error.response.data.message)
      }
    })
  },
  list_counselors({commit}, data) {
    console.log(data)
    axios.get(url + "/admin/list_counselors?page=" + data.page + "&keyword=" + data.keyword,
      {
        headers:{
              'Authorization': cookie.get('user-token') || ''
            }
      })
      .then((response) =>{   
        commit('set_list_counselors', response.data.extra)        
      })
      .catch((errors) =>{
        if (errors.response != undefined){
          alert(errors.response.data.message)
          router.push('/')
        }        
      })
  },
  get_list_contacts({commit}, page){
    axios.get(url+"/admin/list_contacts?page=" + page,
    {
      headers:{
        'Authorization': cookie.get('user-token') || ''
      }
    })
    .then((response) => {
      commit('set_list_contacts', response.data.extra)
    })
    .catch((errors) => {
      if (errors.response != undefined){
        alert(errors.response.data.message)
      }else{
        alert('Không thể tải được dữ liệu')        
      }
      router.push('/admin')
    })
  },
  update_public_status({dispatch, commit, state}, data){
     axios.post(url + "/users/update_public_status",
      data,
      {
        headers: {
          'Authorization': cookie.get('user-token') || ''
        }
    })
    .then((response) => {
      alert(response.data.message)
      dispatch('list_counselors',state.pagination_counselors.current_page)
      // router.push('/admin')
    })
    .catch((errors) => {
      if(errors.response != undefined){
        alert(errors.response.data.message)
      }
    })
  },
  destroy_user({commit}, data){
     axios.post(url + "/users/update_public_status",
      data,
      {
        headers: {
          'Authorization': cookie.get('user-token') || ''
        }
    })
    .then((response) => {
      router.push('/admin')
    })
    .catch((errors) => {
      if(errors.response != undefined){
        alert(errors.response.data.message)
      }
    })
  },
  update_role_user({commit}, data){
    axios.post(url + "/users/change_role",
      data,
      {
        headers: {
          'Authorization': cookie.get('user-token') || ''
        }
    })
    .then((response) => {
      router.push('/admin')
    })
    .catch((errors) => {
      if(errors.response != undefined){
        alert(errors.response.data.message)
      }
    })
  },
  approve_info_update({commit}, id){
    axios.post(url + "/users/approve_update",{id: id},
      {
        headers:{
          'Authorization': cookie.get('user-token') || ''
        }
      }
    )
    .then((response) => {
      alert('Cập nhật thông tin thành công')
      router.push('/admin')
    })
    .catch((errors) => {
      if (errors.response != undefined){
        alert(errors.response.data.message)
      }else{
        alert('Có lỗi trong quá trình cập nhật thông tin')
      }
    })
  },
  update_appointment({commit}, data){
    axios.post(url + "/appointment/update_appointment",
      data,
      {
        headers: {
          'Authorization': cookie.get('user-token') || ''
        }
    })
    .then((response) => {
      alert(response.data.message)
    })
    .catch((errors) => {
      if(errors.response != undefined){
        alert(errors.response.data.message)
      }
    })
  },
  get_list_reviews({commit}, page){
    axios.get(url + "/admin/list_reviews?page=" + page,
    {
      headers:{
        'Authorization': cookie.get('user-token') || ''
      }
    })
    .then((response) => {
      commit('set_list_reviews', response.data.extra)
    })
    .catch((error) => {
      if (error.response != undefined) {
        alert(error.response.data.message)
      }
    })
  },
  update_review({commit, state}, data){
    axios.post(url + "/review/update_review",
      data,
      {
        headers: {
          'Authorization': cookie.get('user-token') || ''
        }
    })
    .then((response) => {
      alert(response.data.message)
    })
    .catch((errors) => {
      if(errors.response != undefined){
        alert(errors.response.data.message)
      }
    })
  },
}
const getters = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vuex_admin.js